import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { RemoteRecordData } from '@client/common/redux/RemoteRecordData';
import { AppState } from '@client/common/redux/store';
import { createAction, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  StatisticsExportParams,
  StatisticsOverallType,
  StatisticsPaginatedType,
  StatisticsQueryParams,
} from 'b2b-common/core/account/api/Statistics.types';

const OVERALL_NAME = 'overallStatistics';
const MANUFACTURERS_NAME = 'manufacturersStatistics';
const PRODUCT_GROUPS_NAME = 'productGroupsStatistics';

export const overallStatisticsSlice = createSlice({
  name: OVERALL_NAME,
  reducerPath: OVERALL_NAME,
  initialState: RemoteRecordData.getDefault(),
  reducers: {
    fetchOverallStatistics: (state, action: PayloadAction<{ startDate: string; endDate: string }>) => {
      state = RemoteRecordData.init();
      return state;
    },
    fetchOverallStatisticsFulfilled: (state, action: PayloadAction<StatisticsOverallType>) => {
      state = RemoteRecordData.fulfill(action.payload);
      return state;
    },
    fetchOverallStatisticsRejected: (state, action: PayloadAction<ErrorType>) => {
      state = RemoteRecordData.reject(action.payload);
      return state;
    },
  },
});

export const manufacturersSlice = createSlice({
  name: MANUFACTURERS_NAME,
  reducerPath: MANUFACTURERS_NAME,
  initialState: RemoteRecordData.getDefault(),
  reducers: {
    fetchManufacturers: (state, action: PayloadAction<StatisticsQueryParams>) => {
      state = RemoteRecordData.init();
      return state;
    },
    fetchManufacturersFulfilled: (state, action: PayloadAction<StatisticsPaginatedType>) => {
      state = RemoteRecordData.fulfill(action.payload);
      return state;
    },
    fetchManufacturersRejected: (state, action: PayloadAction<ErrorType>) => {
      state = RemoteRecordData.reject(action.payload);
      return state;
    },
  },
});

export const productGroupsSlice = createSlice({
  name: PRODUCT_GROUPS_NAME,
  reducerPath: PRODUCT_GROUPS_NAME,
  initialState: RemoteRecordData.getDefault(),
  reducers: {
    fetchProductGroups: (state, action: PayloadAction<StatisticsQueryParams>) => {
      state = RemoteRecordData.init();
      return state;
    },
    fetchProductGroupsFulfilled: (state, action: PayloadAction<StatisticsPaginatedType>) => {
      state = RemoteRecordData.fulfill(action.payload);
      return state;
    },
    fetchProductGroupsRejected: (state, action: PayloadAction<ErrorType>) => {
      state = RemoteRecordData.reject(action.payload);
      return state;
    },
  },
});

export const {
  fetchOverallStatistics,
  fetchOverallStatisticsFulfilled,
  fetchOverallStatisticsRejected,
} = overallStatisticsSlice.actions;

export const {
  fetchManufacturers,
  fetchManufacturersFulfilled,
  fetchManufacturersRejected,
} = manufacturersSlice.actions;

export const {
  fetchProductGroups,
  fetchProductGroupsFulfilled,
  fetchProductGroupsRejected,
} = productGroupsSlice.actions;

const getOverallState = (state: AppState) => state.myAccount.turnoverStatistics.overallStatistics;
const getManufacturersState = (state: AppState) => state.myAccount.turnoverStatistics.manufacturersStatistics;
const getProductGroupsState = (state: AppState) => state.myAccount.turnoverStatistics.productGroupsStatistics;

export const selectOverallStatistics = createSelector(
  getOverallState,
  (state) => new RemoteRecord<StatisticsOverallType>(state),
);

export const selectManufacturers = createSelector(
  getManufacturersState,
  (state) => new RemoteRecord<StatisticsPaginatedType>(state),
);

export const selectProductGroups = createSelector(
  getProductGroupsState,
  (state) => new RemoteRecord<StatisticsPaginatedType>(state),
);

export const exportStatistics = createAction<StatisticsExportParams>('turnoverStatistics/exportStatistics');

